import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import Switch from 'components/switch/Switch';
import Button from 'components/button/Button';
import { useTranslation } from 'react-i18next';
import { QueryKey } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import useDisableIntegrationMutation, {
  IntegrationMutationLevel,
} from 'pages/integrations/hooks/useDisableIntegrationMutation';

const InboundOAuthSwitch = ({
  integrationSetting,
  queryKey,
}: {
  integrationSetting: InternalIntegrationSetting;
  queryKey: QueryKey;
}) => {
  const { t } = useTranslation();
  const { disableIntegration } = useDisableIntegrationMutation();

  const {
    integration: {
      connectionConfig: { connectLink },
    },
    agencySettings: { status },
    enumId,
  } = integrationSetting;

  const isActive = status === IntegrationStatus.ACTIVE;

  return isActive ? (
    <Switch
      data-testid="integration-status-switch"
      className="small"
      checked={isActive}
      onClick={(e) => {
        e.stopPropagation();

        disableIntegration({
          level: IntegrationMutationLevel.AGENCY,
          enumId,
          queryKey,
        });
      }}
    />
  ) : (
    <Link to={connectLink ?? ''} target="_blank" rel="noreferrer">
      <Button
        bsStyle="primary"
        data-testid="connect-via-partner-button"
        className="connect-via-partner-button"
        disabled={!connectLink}
      >
        {t('pageIntegrations.table.connectViaPartner')}
      </Button>
    </Link>
  );
};

export default InboundOAuthSwitch;
